import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Node from "./pages/node";
import Agreement from "./pages/agreement";
import Protocol from "./pages/protocol";
import Home from "./pages/home";

function App() {

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/node" element={<Node/>}/>
                <Route path="/agreement" element={<Agreement/>}/>
                <Route path="/protocol" element={<Protocol/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
